import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";
import useSeo from "@/components/useSeo";

export default function LegalLayout({ title, updated, children, canonical }) {
  useSeo({ title: `${title} · SphereHyx`, description: `${title} for SphereHyx sports club management.`, canonical });
  return (
    <div className="min-h-screen bg-background grain">
      <header className="border-b border-border sticky top-0 bg-background/90 backdrop-blur z-10">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/"><Logo size={28} /></Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1.5" data-testid="legal-back"><ArrowLeft size={15} /> Back to site</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight">{title}</h1>
        {updated && <p className="text-sm text-muted-foreground mt-2">Last updated: {updated}</p>}
        <div className="mt-8 space-y-6 text-sm leading-relaxed text-muted-foreground [&_h2]:text-foreground [&_h2]:font-heading [&_h2]:font-bold [&_h2]:text-lg [&_h2]:mt-8 [&_h2]:mb-2 [&_b]:text-foreground [&_a]:text-primary [&_a]:underline [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5">
          {children}
        </div>
        <p className="mt-12 text-xs text-muted-foreground">Questions? Contact us at <a href="mailto:support@spherehyx.com" className="text-primary underline">support@spherehyx.com</a>.</p>
      </main>
    </div>
  );
}
